import { render, staticRenderFns } from "./Scrap.vue?vue&type=template&id=c2549d64&scoped=true&"
import script from "./Scrap.vue?vue&type=script&lang=js&"
export * from "./Scrap.vue?vue&type=script&lang=js&"
import style0 from "./Scrap.vue?vue&type=style&index=0&id=c2549d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2549d64",
  null
  
)

export default component.exports